import { render, staticRenderFns } from "./ServiceUpdate.vue?vue&type=template&id=e0d418ca"
import script from "./ServiceUpdate.vue?vue&type=script&lang=ts"
export * from "./ServiceUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports